/**
 * Project tutorial stabilizer recommendations by embroidery design type.
 * Elastic searches keyword "stabilizer"; nameHints filter to the appropriate type only.
 */
(function (window) {
    window.prjStabilizerRecommendations = {
        defaultType: "filled",
        elasticKeyword: "stabilizer",
        categoryToType: {
            appliques: "applique",
            applique: "applique",
            "applique projects": "applique",
            "appliqué": "applique",
            "appliqué projects": "applique",
            fsl: "fsl",
            "freestanding lace": "fsl",
            "free standing lace": "fsl",
            lace: "fsl",
            ith: "ith",
            "in the hoop": "ith",
            "in-the-hoop": "ith",
            inthehoop: "ith",
            "in t hoop": "ith",
            redwork: "redwork",
            sketch: "sketch",
            outline: "sketch",
            "bean stitch": "sketch",
            "filled embroidery": "filled",
            filled: "filled",
            fill: "filled",
            monogram: "monogram",
            monograms: "monogram",
            lettering: "monogram",
            quilting: "quilting",
            stippling: "quilting",
            quilt: "quilting",
            cutwork: "cutwork",
            eyelet: "eyelet",
            eyelets: "eyelet",
            "home and garden": "filled",
            "holiday appliques": "applique"
        },
        types: {
            fsl: {
                label: "Freestanding Lace (FSL)",
                recommended: "Water-Soluble (Wash-Away)",
                alternate: "Heavy Water-Soluble (BadgeMaster)",
                nameHints: ["water soluble", "wash away", "badgemaster", "wash"]
            },
            applique: {
                label: "Appliqué",
                recommended: "Tear-Away",
                alternate: "",
                nameHints: ["tear away", "tear-away", "tear"]
            },
            ith: {
                label: "In-the-Hoop (ITH)",
                recommended: "Cut-Away / Poly Mesh",
                alternate: "Tear-Away (for lighter projects)",
                nameHints: ["poly mesh", "polymesh", "cut away", "cut-away", "mesh", "cut"]
            },
            redwork: {
                label: "Redwork",
                recommended: "Tear-Away",
                alternate: "Wash-Away (for delicate fabrics)",
                nameHints: ["tear away", "tear-away", "tear", "wash away", "wash"]
            },
            sketch: {
                label: "Sketch / Outline / Bean Stitch Designs",
                recommended: "Tear-Away",
                alternate: "Wash-Away",
                nameHints: ["tear away", "tear-away", "tear", "wash away", "wash"]
            },
            filled: {
                label: "Filled Embroidery Designs",
                recommended: "Cut-Away",
                alternate: "Heavy Tear-Away OR 2 layers of poly mesh",
                nameHints: ["cut away", "cut-away", "poly mesh", "polymesh", "mesh", "cut"]
            },
            monogram: {
                label: "Monograms / Lettering",
                recommended: "Cut-Away",
                alternate: "Tear-Away",
                nameHints: ["cut away", "cut-away", "cut", "tear away", "tear"]
            },
            quilting: {
                label: "Quilting Designs / Stippling",
                recommended: "Tear-Away",
                alternate: "",
                nameHints: ["tear away", "tear-away", "tear"]
            },
            cutwork: {
                label: "Cutwork",
                recommended: "Water-Soluble",
                alternate: "Cut-Away",
                nameHints: ["water soluble", "wash away", "wash", "cut away", "cut"]
            },
            eyelet: {
                label: "Eyelet Designs",
                recommended: "Water-Soluble",
                alternate: "Tear-Away",
                nameHints: ["water soluble", "wash away", "wash", "tear away", "tear"]
            }
        }
    };
})(this);
